module.exports = __webpack_public_path__ + "img/bandaoti_xiandaoyuan.a240721d.png";